import { doc, getDoc, updateDoc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "@/firebase";

export async function getDeviceById(deviceId) {
  // Try exact match first
  let deviceDoc = await getDoc(doc(db, 'devices', deviceId));
  if (deviceDoc.exists()) {
    return { id: deviceId, ...deviceDoc.data() };
  }
  
  // Try uppercase version
  const upperDeviceId = deviceId.toUpperCase();
  deviceDoc = await getDoc(doc(db, 'devices', upperDeviceId));
  if (deviceDoc.exists()) {
    return { id: upperDeviceId, ...deviceDoc.data() };
  }
  
  return null;
}

export async function updateDevice(deviceId, data) {
  const deviceRef = doc(db, 'devices', deviceId);
  await updateDoc(deviceRef, data);
}

export async function addDevice(deviceId, data) {
  const deviceRef = doc(db, 'devices', deviceId);
  await setDoc(deviceRef, data);
}

export async function deleteDevice(deviceId) {
  const deviceRef = doc(db, 'devices', deviceId);
  await deleteDoc(deviceRef);
}
